import {
  apiClient,
  type ContractListExEntity,
  type PageEntity
} from '@/libs/api'
import { type ContractsRequestQuery } from '@/libs/api/types'

export type FetchContractsQuery = {
  tenantKey: string
  query: ContractsRequestQuery
}

export type FetchContractsResponse = {
  data: ContractListExEntity[]
  pagination: PageEntity | null
}

export const fetchContracts = async (
  { tenantKey, query }: FetchContractsQuery,
  signal?: AbortSignal
): Promise<FetchContractsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .contracts.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
